const MESSAGE_FQY_MODE_UPDATING = 'MESSAGE_FQY_MODE_UPDATING';
const MESSAGE_FQY_MODE_UPDATED_SUCCESS = 'MESSAGE_FQY_MODE_UPDATED_SUCCESS';
const MESSAGE_FQY_MODE_UPDATED_FAILED = 'MESSAGE_FQY_MODE_UPDATED_FAILED';
const MESSAGE_FQY_MODE_FETCHING = 'MESSAGE_FQY_MODE_FETCHING';
const MESSAGE_FQY_MODE_FETCHED_SUCCESS = 'MESSAGE_FQY_MODE_FETCHED_SUCCESS';
const MESSAGE_FQY_MODE_FETCHED_FAILED = 'MESSAGE_FQY_MODE_FETCHED_FAILED';
const LIGHTNING = 'lightning';
const LIGHTNING_MODE = 'Lightning';
const NORMAL = 'normal'
const MSG_FREQ_BUTTON = 'messagefrequency'

export {
    MESSAGE_FQY_MODE_UPDATING,
    MESSAGE_FQY_MODE_UPDATED_SUCCESS,
    MESSAGE_FQY_MODE_UPDATED_FAILED,
    MESSAGE_FQY_MODE_FETCHING,
    MESSAGE_FQY_MODE_FETCHED_SUCCESS,
    MESSAGE_FQY_MODE_FETCHED_FAILED,
    LIGHTNING,
    NORMAL,
    MSG_FREQ_BUTTON,
    LIGHTNING_MODE
}